import { LocalizedString } from '.';

export interface MarketingActionButton {
  action: MarketingTrayButtonAction;
  labelLocalized: LocalizedString;
  targetContentGuid: string;
  targetPageSlug: string;
  targetUrl: string;
}

export enum MarketingTrayButtonAction {
  SignIn = 'SignIn',
  SignUp = 'SignUp',
  CustomUrl = 'CustomUrl',
  NewPassword = 'NewPassword',
  CxbPage = 'CxbPage',
  Content = 'Content',
  RenewOrCompleteSubscription = 'RenewOrCompleteSubscription',
}

export enum MarketingDescriptionStyle {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}
export enum MarketingTextStyle {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export enum MarketingTitleStyle {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export enum MarketingTrayLayout {
  LeftAligned = 'LeftAligned',
  RightAligned = 'RightAligned',
}

export enum MarketingStudioTrayLayout {
  Centered = 'Centered',
}

export enum MarketingEmailLayout {
  LeftAligned = 'LeftAligned',
  RightAligned = 'RightAligned',
  Centered = 'Centered',
}

export enum MarketingMultipleContentTitleBannerLayout {
  Landscape = 'Landscape',
  Portrait = 'Portrait',
}

export interface MarketingOrderedText {
  text: string;
  order: number;
}

export enum DetailedPageMarketingBannerLayout {
  LeftAligned = 'LeftAligned',
  RightAligned = 'RightAligned',
  Centered = 'Centered',
}
